<template>
  <div class="v3-popup score-detail-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content large">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <table>
          <thead>
            <tr>
              <th>項目</th>
              <th>積分變化</th>
              <th>時間</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in scoreLogList" :key="item.ID">
              <td>{{ getTaskName(item) }}</td>
              <td>{{ getCurScore(item) }}</td>
              <td>{{ item.CREATE_TIME }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="v3-popup-content-footer">
        <div
          class="page-pre"
          :class="{ un: page <= 1 }"
          @click="handlePrevPage"
        ></div>
        <template
          v-for="(pageNum, index) in displayPages"
          :key="`${pageNum}-${index}`"
        >
          <div v-if="pageNum === '...'" class="page-num">...</div>
          <div
            v-else
            class="page-num"
            :class="{ active: pageNum === page }"
            @click="handlePageClick(pageNum)"
          >
            {{ pageNum }}
          </div>
        </template>
        <div
          class="page-next"
          :class="{ un: page >= totalPages }"
          @click="handleNextPage"
        ></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, ref, watch, computed } from "vue";
import { getActivityApi, getJSON } from "@utils";
import { taskText } from "@config";

const v3PopupState = inject("v3PopupState", reactive({}));
const showCurErrorTips = inject("showCurErrorTips", () => {});

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const page = ref(1);
const scoreLogList = ref([]);
const total = ref(0);
const pageSize = 5;

// 计算总页数
const totalPages = computed(() => {
  return Math.ceil(total.value / pageSize) || 1;
});

// 计算要显示的页码
const displayPages = computed(() => {
  const pages = [];
  const total = totalPages.value;

  if (total <= 5) {
    // 总页数不超过7页，全部显示
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    // 总页数超过7页，显示前4页+省略号+后3页
    for (let i = 1; i <= 2; i++) {
      pages.push(i);
    }
    pages.push("...");
    for (let i = total - 2; i <= total; i++) {
      pages.push(i);
    }
  }

  return pages;
});

// 关闭弹窗
const handleClose = () => {
  v3PopupState.scoreDetailPopupState = false;
};

const getCurScore = (item) => {
  let d = item.SCORE_TYPE == 2 ? "-" : "";
  return `${d}${item.SCORE}`;
};

const excGetList = async () => {
  let res = await getJSON(
    getActivityApi(window.platform_id, window.activity_name, "scoreLog"),
    {
      params: JSON.stringify({
        page: page.value,
        pageSize: pageSize,
      }),
    }
  );

  if (res.result != 1) {
    showCurErrorTips(res.code);
    return;
  }

  scoreLogList.value = res.data.scoreLog || [];
  total.value = res.data.total || 0;
};

const getTaskName = (config) => {
  if (config.SCORE_TYPE == 2) {
    return "積分抽獎";
  }
  return taskText.find((item) => item.key === config.TASK_ID)?.title || "";
};

const switchPage = (pageNum) => {
  page.value = pageNum;
  excGetList();
};

// 上一页
const handlePrevPage = () => {
  if (page.value > 1) {
    switchPage(page.value - 1);
  }
};

// 下一页
const handleNextPage = () => {
  if (page.value < totalPages.value) {
    switchPage(page.value + 1);
  }
};

// 点击页码
const handlePageClick = (pageNum) => {
  if (pageNum !== page.value) {
    switchPage(pageNum);
  }
};

const init = async () => {
  scoreLogList.value = [];
  page.value = 1;
  await excGetList();
};

watch(
  () => v3PopupState.scoreDetailPopupState,
  (value) => {
    console.log("scoreDetailPopupState", value);
    if (value) {
      init();
    } else {
      scoreLogList.value = [];
      page.value = 1;
    }
  }
);
</script>

<style scoped lang="less"></style>
